import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Bird, Plus } from "lucide-react";
import { useState } from "react";
import { LossDialog } from "@/components/interface/LossDialog";
import { useStockItems } from "@/hooks/useStockItems";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

interface QuickActionsProps {
  onAddTransaction: () => void;
  onAddPoultry: () => void;
}

export const QuickActions = ({ onAddTransaction, onAddPoultry }: QuickActionsProps) => {
  const [isLossDialogOpen, setIsLossDialogOpen] = useState(false);
  const [lossQuantity, setLossQuantity] = useState("");
  const { data: stockItems, refetch } = useStockItems();

  const handleConfirm = async (quantity: number, selectedProductId: string) => {
    try {
      const { error } = await supabase
        .from('stock_items')
        .update({ 
          quantity: quantity 
        })
        .eq('id', selectedProductId);

      if (error) throw error;
      
      toast.success("Stock mis à jour avec succès");
      setIsLossDialogOpen(false);
      refetch();
    } catch (error: any) {
      toast.error("Erreur lors de la mise à jour du stock");
      console.error(error);
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <Card>
        <CardContent className="p-6 space-y-2">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <Bird className="h-5 w-5 text-primary" />
              <h3 className="text-lg font-medium">Volailles</h3>
            </div>
            <Button variant="outline" size="sm" onClick={onAddPoultry}>
              <Plus className="h-4 w-4 mr-2" />
              Ajouter
            </Button>
          </div>
          <p className="text-sm text-muted-foreground">
            Gérez vos volailles et suivez leur croissance
          </p>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-6 space-y-2">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-2">
              <Bird className="h-5 w-5 text-primary" />
              <h3 className="text-lg font-medium">Transactions</h3>
            </div>
            <Button variant="outline" size="sm" onClick={onAddTransaction}>
              <Plus className="h-4 w-4 mr-2" />
              Ajouter
            </Button>
          </div>
          <p className="text-sm text-muted-foreground">
            Enregistrez vos achats et ventes de volailles
          </p>
        </CardContent>
      </Card>

      <LossDialog 
        open={isLossDialogOpen}
        onOpenChange={setIsLossDialogOpen}
        lossQuantity={lossQuantity}
        onQuantityChange={setLossQuantity}
        onConfirm={handleConfirm}
        stockItems={stockItems || []}
      />
    </div>
  );
};